






















































import Vue from 'vue';
import layout from '@/libs/layout/educational/course-teaching';
import { Component } from 'vue-property-decorator';
import { getTeachingCoursePage } from '@/api/educational';
import { TTeachingCoursePage } from '@/types/views/educational';
import { TLayout } from '@/types/utils';
@Component({})
export default class Course extends Vue {
  private query = '';
  private layout: TLayout = layout;
  private page: TTeachingCoursePage = {
    currentPage: 1,
    pageSize: 20
  };
  private activated() {
    this.search();
  }
  handleSize(size: number) {
    this.getCoursePage({
      courseName: this.query,
      currentPage: 1,
      pageSize: size
    });
  }
  handlePage(page: number) {
    this.getCoursePage({
      courseName: this.query,
      currentPage: page,
      pageSize: this.page.pageSize
    });
  }
  private async getCoursePage(options: any) {
    try {
      this.page = await getTeachingCoursePage(options);
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  private async goToCourseDetail(id: number) {
    this.$router.push({
      path: `/educational/course-detail/${id}`
    });
  }
  // 上课时间
  private getClassTime(date: Date) {
    let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    let minute =
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    return `${hour}:${minute}`;
  }
  private search() {
    this.getCoursePage({
      currentPage: 1,
      pageSize: 20,
      courseName: this.query
    });
  }
}
